import React from 'react';
import Image from '../../../components/AppImage'; // Ensure this path is correct for your project
import styles from './ClientLogos.module.css';   // Import the CSS module

const ClientLogos = () => {
  // IMPORTANT: Replace these placeholder URLs with the actual paths to your images.
  const allPartnerLogos = [
    { id: 1, name: 'Partner One', logo: '/assets/brazil.jpg' },
    { id: 2, name: 'Partner Two', logo: '/assets/jkuat.jpg' },
    { id: 3, name: 'Partner Three', logo: '/assets/microsoft.jpg' },
    { id: 4, name: 'Partner Four', logo: '/assets/kenyattauniversity.jpg' },
    { id: 5, name: 'Partner Five', logo: '/assets/hub.jpg' },
    { id: 6, name: 'Partner Six', logo: '/assets/kenchick.jpg' },
    { id: 7, name: 'Partner Seven', logo: '/assets/kenyaair.jpg' },
    { id: 8, name: 'Partner Eight', logo: '/assets/food.jpg' },
    { id: 9, name: 'Partner Nine', logo: '/assets/de la rue.jpg' },
    { id: 10, name: 'Partner Ten', logo: '/assets/old mutual.jpg' },
    { id: 11, name: 'Partner Eleven', logo: '/assets/radio.jpg' },
    { id: 12, name: 'Partner Twelve', logo: '/assets/ZETECH.jpg' },
    { id: 13, name: 'Partner Thirteen', logo: '/assets/showmax.jpg' },
    { id: 14, name: 'Partner Fourteen', logo: '/assets/tamarid.jpg' },
    { id: 15, name: 'Partner Fifteen', logo: '/assets/tea.jpg' },
    { id: 16, name: 'Partner Sixteen', logo: '/assets/safaripark.png' },
    { id: 17, name: 'Partner seventeen', logo: '/assets/media.png' },
    // Add more logos as needed following the same path format
  ];

  // Automatically split the logos into two even rows
  const halfwayPoint = Math.ceil(allPartnerLogos.length / 2);
  const firstRowLogos = allPartnerLogos.slice(0, halfwayPoint);
  const secondRowLogos = allPartnerLogos.slice(halfwayPoint);

  /**
   * Scroller component that renders a single row of logos.
   * It duplicates the logos to create a seamless infinite loop.
   */
  const Scroller = ({ logos, direction }) => {
    // We duplicate the logos array to create the illusion of an infinite loop
    const duplicatedLogos = [...logos, ...logos];

    return (
      <div className={styles.scroller} data-direction={direction}>
        <div className={styles.scrollerInner}>
          {duplicatedLogos.map((client, index) => (
            <div key={index} className="flex-shrink-0 w-32 h-16">
              <Image
                src={client.logo}
                alt={client.name}
                className="w-full h-full object-contain grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    // THE ONLY CHANGE IS HERE: Added "overflow-hidden" to this className
    <div className="bg-card rounded-xl elevation-card p-6 overflow-hidden">
      <div className="text-center mb-8">
        <h3 className="font-heading font-bold text-2xl text-foreground mb-2">
          Trusted Partners
        </h3>
        <p className="font-body text-muted-foreground">
          We collaborate with industry-leading vendors to deliver exceptional experiences
        </p>
      </div>

      {/* Render the two scrolling rows */}
      <div className="flex flex-col gap-8">
        <Scroller logos={firstRowLogos} direction="left" />
        <Scroller logos={secondRowLogos} direction="right" />
      </div>

      <div className="mt-12 text-center">
        <p className="font-body text-sm text-muted-foreground mb-4">
          Join over 500+ satisfied clients who trusted us with their special moments
        </p>
        <div className="flex items-center justify-center space-x-8">
          <div className="text-center">
            <p className="font-heading font-bold text-2xl text-primary">500+</p>
            <p className="font-caption text-xs text-muted-foreground">Events Planned</p>
          </div>
          <div className="text-center">
            <p className="font-heading font-bold text-2xl text-accent">98%</p>
            <p className="font-caption text-xs text-muted-foreground">Client Satisfaction</p>
          </div>
          <div className="text-center">
            <p className="font-heading font-bold text-2xl text-success">5★</p>
            <p className="font-caption text-xs text-muted-foreground">Average Rating</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientLogos;